import React, { useId } from 'react'
import PropTypes from 'prop-types'
import styled, { useTheme } from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'

const DesktopContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.neutralW30};
  color: ${({ theme }) => theme.colors.neutralW90};
  font-family: ${({ theme }) => theme.fonts?.primary || 'Nunito Sans'};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
  font-variation-settings:
    'YTLC' 500,
    'wdth' 100;
`

const DesktopCheckbox = styled(Tonality.Checkbox)`
  svg {
    width: 12px;
    height: 12px;
  }
`

const DesktopLabel = styled.label`
  min-width: 48px;
  cursor: pointer;
`

const CompactContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.neutralW90};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`

const CompactLabel = styled.label`
  cursor: pointer;
`

const ArchivedFilter = ({ checked, label, onChange, compact = false }) => {
  const checkboxId = useId()
  const theme = useTheme()
  // DSNY Checkbox has no player setting; unchecked is always white0
  const uncheckedStyle = checked
    ? {}
    : { background: 'transparent', borderColor: theme.colors.neutralW90 }

  if (compact) {
    return (
      <CompactContainer>
        <Tonality.Checkbox
          aria-label={label}
          checked={checked}
          data-cy="archived-filter"
          id={checkboxId}
          mode="dark"
          style={{ width: 20, height: 20, ...uncheckedStyle }}
          wrapperStyle={{ display: 'flex' }}
          onChange={onChange} />
        <CompactLabel htmlFor={checkboxId}>{label}</CompactLabel>
      </CompactContainer>
    )
  }

  return (
    <DesktopContainer>
      <DesktopCheckbox
        aria-label={label}
        checked={checked}
        data-cy="archived-filter"
        id={checkboxId}
        mode="dark"
        style={{
          boxSizing: 'border-box',
          width: 14,
          height: 14,
          borderRadius: 2,
          ...uncheckedStyle
        }}
        wrapperStyle={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: '0 0 16px',
          width: 16,
          height: 16
        }}
        onChange={onChange} />
      <DesktopLabel htmlFor={checkboxId}>{label}</DesktopLabel>
    </DesktopContainer>
  )
}

ArchivedFilter.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  compact: PropTypes.bool
}

export default ArchivedFilter
